import { render, staticRenderFns } from "./CompanyInfo_UploadSalesCosts.vue?vue&type=template&id=622bc2ee&scoped=true"
import script from "./CompanyInfo_UploadSalesCosts.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_UploadSalesCosts.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_UploadSalesCosts.vue?vue&type=style&index=0&id=622bc2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bc2ee",
  null
  
)

export default component.exports